function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Text } from 'grommet';
import styled from 'styled-components';
import Divider from 'granite-admin/core/components/Divider';
const StyledBox = styled(Box)`
  cursor: pointer;
`;
// eslint-disable-next-line react/display-name
const Steps = /*#__PURE__*/React.memo(({
  className,
  async,
  children,
  direction,
  activeStep: defaultActiveStep,
  onChange,
  navigationVisible,
  steps,
  ...rest
}) => {
  const [activeStep, setActiveStep] = useState(defaultActiveStep);
  if (!Array.isArray(children)) children = [children];
  useEffect(() => {
    setActiveStep(defaultActiveStep);
  }, [defaultActiveStep]);
  const handleStepTitleClickAsync = async index => {
    try {
      let isAllowed = true;
      isAllowed = await onChange(index, activeStep);
      if (isAllowed) setActiveStep(index);
    } catch (error) {
      console.error(error);
    }
  };
  const handleStepTitleClick = index => {
    const isAllowed = onChange(index, activeStep);
    if (isAllowed) setActiveStep(index);
  };
  const stepsNavigation = steps.map((step, i) => {
    if (!navigationVisible) return null;
    const isActive = i === activeStep;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: step.title
    }, /*#__PURE__*/React.createElement(StyledBox, {
      align: "center",
      direction: "row",
      key: step.title,
      gap: "xsmall",
      onClick: () => async ? handleStepTitleClickAsync(i) : handleStepTitleClick(i)
    }, step.icon ? step.icon : /*#__PURE__*/React.createElement(Button, {
      label: i + 1,
      primary: isActive
    }), /*#__PURE__*/React.createElement(Text, {
      weight: isActive ? 'bold' : 'normal'
    }, step.title)), i !== steps.length - 1 && direction === 'row' && /*#__PURE__*/React.createElement(Box, {
      flex: "grow"
    }, /*#__PURE__*/React.createElement(Divider, {
      align: "start",
      color: i < activeStep ? 'brand' : null
    })));
  });
  return /*#__PURE__*/React.createElement(Box, {
    direction: direction === 'column' ? 'row' : 'column',
    className: className
  }, /*#__PURE__*/React.createElement(Box, _extends({
    align: direction === 'row' ? 'center' : null,
    direction: direction,
    gap: "medium"
  }, rest), navigationVisible && stepsNavigation), steps[activeStep].content);
});
Steps.defaultProps = {
  async: false,
  direction: 'row',
  activeStep: 0,
  onChange: () => true,
  navigationVisible: true
};
Steps.propTypes = {
  async: PropTypes.bool,
  activeStep: PropTypes.number,
  direction: PropTypes.oneOf(['row', 'column']),
  onChange: PropTypes.func,
  navigationVisible: PropTypes.bool,
  steps: PropTypes.array,
  className: PropTypes.string,
  children: PropTypes.any
};
export default Steps;